import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import analytics from '@/shared-utils/analytics'
import { GA4Event, GA4PageName, GA4Product } from '@/shared-utils/ga4/types'

export default function fireOnSubmitEvent(data: string) {
  analytics.fireEvent({
    action: 'Cruises Search Button',
    category: ANALYTICS_CATEGORY_HOME,
    data
  })
  analytics.fireEvent({
    action: 'Cruises Search',
    category: ANALYTICS_CATEGORY_HOME,
    data: 'Valid'
  })
  analytics.fireGA4Event({
    event: GA4Event.SEARCH,
    attributes: {
      product_name: GA4Product.NONPATH,
      page_name: GA4PageName.PCLN_HOME,
      data
    }
  })
}
